<template>
    <md-card>
        <md-card-header>
        <h4 class="title">
            <md-icon>headset_mic</md-icon>상담원
        </h4>
        </md-card-header>
        <md-card-content>
        <md-table :value="counselorList" class="paginated-table table-striped table-hover text-align-center">
            <md-table-row slot="md-table-row" slot-scope="{ item }">
            <md-table-cell md-label=""><input type="checkbox" v-model="item.checked" /></md-table-cell>
            <md-table-cell md-label="상담원">{{ item.userNm }}</md-table-cell>
            <md-table-cell md-label="배정인원">
                <input type="text" v-model="item.distCnt" @keyup="getTotalCount">
            </md-table-cell>
            </md-table-row>
        </md-table>
        <div style="text-align: right; border-top: 1px solid #ddd; padding-top: 5px;">
            <!-- 합계 : {{totalCount}} / 총 : {{this.cmpResultListCnt}} -->
            합계 : {{totalCount}} / 총 : {{totalTargetMemberCnt}}
        </div>
        </md-card-content>

        <md-card-actions md-alignment="right">
        <select v-model="selectedCmpLType">
          <option value="">콜 용도 선택</option>
          <option v-for="item in cmpLTypeList" :key="item.code" :label="item.codeNm" :value="item.code">
            {{ item }}
          </option>
        </select>
        <md-button class="md-info md-sm" @click="distCmpResultList();"><md-icon>call_split</md-icon>배분처리</md-button>
        <md-button class="md-info md-sm" @click="equalDistribution();"><md-icon>vertical_split</md-icon>균등배분</md-button>
        </md-card-actions>
    </md-card>
</template>
<script>
import URL_CONST from "@/kuaa/kuaa-url-const";
import Swal from "sweetalert2";
import moment from "moment";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import kuaaApi from "@/kuaa/kuaa-api";

export default {
  name: "userListComp",
  props: {
      totalTargetMemberCnt : {
          type: Number,
          default : 0
      }
  },

  components: {
    
  },

  created() {
    this.getUserList();
    this.searchCmpLTypes();
  },

  data(){
    return {
      total : 0,
      totalCount : 0,
      cmpLTypeList: [],
      selectedCmp: null,
      selectedCmpLType: "",

      counselorList: [],
      cmpResultListCnt: 0
    }
  },

  methods: {
    setCmp(item) {
      this.selectedCmp = item;
    },

    searchCmpLTypes() {
      kuaaFnc.fncCmpLTypes(null,res => {
        this.cmpLTypeList = res.data.data.contents;
      });
    },

    getUserList() {
      let options = {
        userRight : "1"
      };
      kuaaApi.sendServer(URL_CONST.GET_USER_LIST, options, "post", response => {
        this.counselorList = response.data.data.contents;

        this.counselorList.forEach((item)=>{
          item.distCnt = 0;
        });
      });
    },

    setCmpResultListCnt(cnt) {
      this.cmpResultListCnt = cnt;
    },

    equalDistribution() {
      // 체크박스가 선택된 사람에게만 균등배분함
	  
      let cmpResultLen = this.totalTargetMemberCnt;
      let checkedList = this.counselorList.filter(function(item) {
        return item.checked;
      });

      if (checkedList.length === 0) {
        kuaaFnc.showSwal("균등배분", '균등배분할 상담원을 선택해 주세요');
        return false;
      }

      let gap = Math.ceil(cmpResultLen / checkedList.length);

      let temp = [];

      this.counselorList.forEach((item)=>{
        item.distCnt = 0;
        if (!item.checked) {
          temp.push(item);
          return;
        }

        cmpResultLen = cmpResultLen - gap;

        if (cmpResultLen >= 0) {
          item.distCnt = gap;
        } else {
          item.distCnt = (cmpResultLen + gap) % gap;
        }

        temp.push(item);
      });
      
      this.counselorList = temp;
      this.getTotalCount();
    },

    distCmpResultList() {
      if (!this.selectedCmp) {
        kuaaFnc.showSwal("배분처리", '캠페인을 먼저 선택하세요');
      } else if (!this.selectedCmpLType) {
        kuaaFnc.showSwal("배분처리", '콜 용도를 먼저 선택하세요');
      } else {
        let options = [];
        let cnt = 0;

        this.counselorList.forEach((item, i)=>{
          if (!item.checked) {
            return;
          }

          cnt += item.distCnt;
          let obj = {
            cAgentId: item.userNo,
            cCmpId: this.selectedCmp.CCmpId,
            cCustGrpId: this.selectedCmp.CCustGrpId,
            distCnt: item.distCnt,
            calluseCd: this.selectedCmpLType
          };

          if (i === 0) {
            obj.calluseCd = this.selectedCmpLType;
          }
          options.push(obj);
        });

        if(options.length == 0){
          kuaaFnc.showSwal("배분처리", '배분처리할 상담원을 선택해 주세요');
          return false;
        }
        if(cnt == 0){
          kuaaFnc.showSwal("배분처리", '배정인원을 정확하게 입력해 주세요');
          return false;
        }

        Swal.fire(kuaaFnc.getSwalModaloptions('confirm',{
          html: "배분 하시겠습니까?",
        })).then(result => {
          if (result.value) {
            kuaaApi.sendServer(URL_CONST.DIST_CMP_RESULT_LIST, options, "post", response => {
              if (response.data.success) {
                this.$emit('returnDistCmpResultSuccess', this.selectedCmp);
                this.getUserList();
              }
            });
          }
        });
      }
    },

    getTotalCount(){
        let count = 0;
        this.counselorList.forEach(obj=>{
            count += parseInt(obj.distCnt);
        })
        this.totalCount = count;
    }
  }
}
</script>

<style lang="css" scoped>
</style>